/**
 * @flow
 * @relayHash eebbf330a946d716cc946d801aceac1e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type vocabularyList_viewer$ref = any;
export type vocabularyPage_list_QueryVariables = {||};
export type vocabularyPage_list_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: vocabularyList_viewer$ref
  |}
|};
export type vocabularyPage_list_Query = {|
  variables: vocabularyPage_list_QueryVariables,
  response: vocabularyPage_list_QueryResponse,
|};
*/


/*
query vocabularyPage_list_Query {
  viewer {
    ...vocabularyList_viewer
    id
  }
}

fragment vocabularyList_viewer on Viewer {
  vocabulary {
    edges {
      node {
        ...vocabularyListItem_item
        id
      }
    }
  }
}

fragment vocabularyListItem_item on Vocabulary {
  id
  name
  value
  description
  canDelete
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "vocabularyPage_list_Query",
  "id": null,
  "text": "query vocabularyPage_list_Query {\n  viewer {\n    ...vocabularyList_viewer\n    id\n  }\n}\n\nfragment vocabularyList_viewer on Viewer {\n  vocabulary {\n    edges {\n      node {\n        ...vocabularyListItem_item\n        id\n      }\n    }\n  }\n}\n\nfragment vocabularyListItem_item on Vocabulary {\n  id\n  name\n  value\n  description\n  canDelete\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "vocabularyPage_list_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "vocabularyList_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "vocabularyPage_list_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vocabulary",
            "storageKey": null,
            "args": null,
            "concreteType": "VocabularyConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "VocabularyEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Vocabulary",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "value",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canDelete",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0353667cb0f50739ff0616736243865e';
module.exports = node;



// WEBPACK FOOTER //
// src/components/vocabulary/__generated__/vocabularyPage_list_Query.graphql.js